import job_search_card_list_0 from "file:///home/wldocker/wl-cms/sites/modules/job-search-card-list-widget/ui/src/job-search-card-list.js";



import job_search_card_list_0Stylesheet from "file:///home/wldocker/wl-cms/sites/modules/job-search-card-list-widget/ui/src/job-search-card-list.scss";job_search_card_list_0();